<template>
  
      

  <div id="app">
    <p>Sunucu Bağlantısı: <span class="status">{{ apiLink }}</span></p>
      <div class="container">
       
        <div class="card">
      <a href="https://www.irfanyildirim.com.tr" class="custom-button">
        <span class="icon">🔥</span>
        Drupal
      </a>
      <a href="https://basicwebsite.rfnnet.com" class="custom-button">
        <span class="icon">🔥</span>
        Basic Web Site
      </a>

        </div>

        <div class="card">
      <a :href="apiLink + '/firebase'" class="custom-button">
        <span class="icon">🔥</span>
        Firebase Sayfasına Git
      </a>
      <a href="https://github.com/createand" class="custom-button">
        <span class="icon">🔥</span>
        createand github
      </a>
        </div>

        <div class="card">
      <a href="https://robotreport.rfnnet.com" class="custom-button">
        <span class="icon">🔥</span>
        Robot Rapor
      </a>
      <a href="https://cloudflare.rfnnet.com" class="custom-button">
        <span class="icon">🔥</span>
        MkDocs
      </a>
        </div>
      </div>
   

    <div style="display: flex; flex-wrap: wrap; gap: 20px; justify-content: center; align-items: flex-start; margin-bottom: 40px;">
    
    <div style="flex: 1; min-width: 300px; max-width: 500px; background: #fff; padding: 15px; border-radius: 12px; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
      <h2 style="text-align: center; font-size: 1.2rem;">Şehir Dağılım Grafiği</h2>
      <canvas id="myChart"></canvas>
    </div>

    <div style="flex: 1; min-width: 300px; max-width: 500px; background: #fff; padding: 15px; border-radius: 12px; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
        <h2 style="text-align: center; font-size: 1.2rem;">Kategori Dağılımı (Elasticsearch)</h2>
        <canvas id="elasticChart"></canvas>
    </div>

</div>
<h1>Kişiler Listesi</h1>
    <div v-if="loading">
      Yükleniyor...
    </div>
    
    <div v-else-if="error">
      Hata: {{ error }}
    </div>
    
    <div v-else>
      <p>Toplam: {{ kisiler.length }} kişi</p>
      
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th v-for="key in columns" :key="key">{{ key }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(kisi, index) in kisiler" :key="index">
            <td>{{ index + 1 }}</td>
            <td v-for="key in columns" :key="key">{{ kisi[key] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <h2>PostgreSQL Verileri:</h2>
<div>
  <table>
  <thead>
    <tr>
      <th>#</th>
    
      <th>İsim</th>
      <th>Soyisim</th>
      <th>Email</th>
      <th>Şehir</th>
      <th>Yaş</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(record, index) in postgresRecords" :key="record.id">
      <td>{{ index + 1 }}</td>
      <td>{{ record.name }}</td>
      <td>{{ record.surname }}</td>
      <td>{{ record.email }}</td>
      <td>{{ record.city }}</td>
      <td>{{ record.age }}</td>
    </tr>
  </tbody>
</table>
</div>
<p></p><br />
<div class="container2">
    <div class="board">
      
      <div class="panel">
        <h3>🚀 Aktif Servisler</h3>
        <draggable 
          v-model="activeServices" 
          group="services" 
          item-key="id"
          class="drag-area"
          ghost-class="ghost"
        >
          <template #item="{ element }">
            <div class="card drag-card">
              <span class="icon">{{ element.icon }}</span>
              {{ element.name }}
            </div>
          </template>
        </draggable>
      </div>

      <div class="panel">
        <h3>⏳ Beklemedekiler</h3>
        <draggable 
          v-model="pendingServices" 
          group="services" 
          item-key="id"
          class="drag-area"
          ghost-class="ghost"
        >
          <template #item="{ element }">
            <div class="card drag-card secondary">
              <span class="icon">{{ element.icon }}</span>
              {{ element.name }}
            </div>
          </template>
        </draggable>
      </div>

    </div>
  </div>
</template>

<script setup>
  import { ref, watch, onMounted } from 'vue';
  import draggable from 'vuedraggable';
  
  const apiLink = ref(`${process.env.VUE_APP_LINK_URL}`);

  // 1. Başlangıçta listeleri boş tanımlıyoruz
const activeServices = ref([]);
const pendingServices = ref([]);

// 2. Sayfa yüklendiğinde (Mount olduğunda) veriyi çekiyoruz
onMounted(() => {
  const savedActive = localStorage.getItem('activeList');
  const savedPending = localStorage.getItem('pendingList');

  // Eğer LocalStorage'da veri varsa onları bas, yoksa varsayılanları koy
  activeServices.value = savedActive ? JSON.parse(savedActive) : [
  { id: 1, name: 'Firebase', icon: '🔥' },
  { id: 2, name: 'Elasticsearch', icon: '🔍' }
  ];

  pendingServices.value = savedPending ? JSON.parse(savedPending) : [
  { id: 3, name: 'Drupal', icon: '' },
  { id: 4, name: 'Redis', icon: '⚡' }
  ];
});


// 3. İzleyici: Sadece veriler gerçekten değiştiğinde hem LocalStorage'a hem Backend'e yaz
watch([activeServices, pendingServices], () => {
  // LocalStorage güncelleme
  localStorage.setItem('activeList', JSON.stringify(activeServices.value));
  localStorage.setItem('pendingList', JSON.stringify(pendingServices.value));

  // Opsiyonel: Backend'e gönder (CORS ve URL ayarların tam ise)
  // sendToBackend(); 
}, { deep: true });

</script>



<script>

import axios from 'axios'
//import { ref } from 'vue';
// 1. Chart.js'i import et
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);


// Ortama göre otomatik olarak .env dosyasındaki değeri alır
//const apiLink = ref(`${process.env.VUE_APP_LINK_URL}`);

export default {
  name: 'App',
  data() {
    return {
      kisiler: [],
      columns: [],
      loading: true,
      postgresRecords: [],
      error: null,
      chartInstance: null
    }
  },
  mounted() {
    this.verileriCek();
    this.fetchPostgresData();
  },
  methods: {
    async verileriCek() {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/api/data`);
        const data = await response.json();
        this.kisiler = data;

        this.$nextTick(() => {
        this.elasticGrafikOlustur();
      });
        
        // İlk kişiden sütun isimlerini al
        if (data.length > 0) {
          this.columns = Object.keys(data[0]);
        }
        
        this.loading = false;
      } catch (err) {
        this.error = err.message;
        this.loading = false;
      }
    },
    elasticGrafikOlustur() {
    const ctx = document.getElementById('elasticChart').getContext('2d');

    // 1. Veriyi Grupla (Örn: Veri içindeki 'category' alanına göre)
    // Not: record._source.category gibi bir yapı olabilir, verinin yapısına göre düzenle
    const kategoriSayilari = this.kisiler.reduce((acc, curr) => {
      // Elasticsearch genellikle _source içinde döner
      const cat = curr._source ? curr._source.sehir : curr.sehir; 
      acc[cat] = (acc[cat] || 0) + 1;
      return acc;
    }, {});

    

    if (this.elasticChartInstance) {
      this.elasticChartInstance.destroy();
    }

    // 2. Pasta Grafiği Oluştur
    this.elasticChartInstance = new Chart(ctx, {
      type: 'doughnut', // Pasta grafiği
      data: {
        labels: Object.keys(kategoriSayilari),
        datasets: [{
          data: Object.values(kategoriSayilari),
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#4BC0C0',
            '#9966FF'
          ],
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: { position: 'bottom' }
        }
      }
    });
  },
    async fetchPostgresData(){
    axios.get(`${process.env.VUE_APP_API_URL}/api/records`).then(response => {
      this.postgresRecords = response.data;

      // Veri geldikten sonra grafiği çizdir
      this.$nextTick(() => {
          this.grafikOlustur();
        });

    })
    .catch(error => {
      console.error("PostgreSQL verilerini alırken hata:", error)
    })    
  },

  grafikOlustur() {
      const ctx = document.getElementById('myChart').getContext('2d');
      
      // Şehirleri sayalım (Örn: { "İstanbul": 3, "Ankara": 1 })
      const sehirSayilari = this.postgresRecords.reduce((acc, current) => {
        acc[current.city] = (acc[current.city] || 0) + 1;
        return acc;
      }, {});

      // Eğer eski bir grafik varsa yok et (re-render için önemli)
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      this.chartInstance = new Chart(ctx, {
        type: 'bar', // 'pie', 'line' veya 'doughnut' yapabilirsin
        data: {
          labels: Object.keys(sehirSayilari), // Şehir isimleri
          datasets: [{
            label: 'Şehirdeki Kişi Sayısı',
            data: Object.values(sehirSayilari), // Sayılar
            backgroundColor: [
              'rgba(76, 175, 80, 0.6)',
              'rgba(54, 162, 235, 0.6)',
              'rgba(255, 206, 86, 0.6)'
            ],
            borderColor: '#4CAF50',
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            y: { beginAtZero: true }
          }
        }
      });
    }
  }
}
</script>

<style>
#app {
  font-family: Arial, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  color: #333;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

th {
  background: #4CAF50;
  color: white;
  padding: 12px;
  text-align: left;
  font-weight: bold;
}

td {
  padding: 10px 12px;
  border-bottom: 1px solid #ddd;
}

tr:hover {
  background: #f5f5f5;
}

tr:nth-child(even) {
  background: #f9f9f9;
}

tr:nth-child(even):hover {
  background: #f0f0f0;
}

.grafik-konteynir {
  display: flex;         /* Yan yana getirme özelliği */
  flex-direction: row;   /* Yan yana diz */
  flex-wrap: wrap;       /* Sığmazsa alt satıra geç */
  gap: 20px;            /* İki grafik arasındaki boşluk */
  justify-content: space-around; /* Ortalamak için */
  align-items: flex-start;
  margin-bottom: 50px;
}

.grafik-kutusu {
  flex: 1;               /* Eşit alan kaplasınlar */
  min-width: 300px;      /* Çok küçülmelerini engelle */
  max-width: 550px;      /* Çok devasa olmalarını engelle */
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
</style>


<style scoped>

  /* Mevcut CSS'lerine ek olarak şunları ekleyebilirsin */
.container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 40px;
  font-family: sans-serif;
  gap: 30px;
}

.card {
  background: #ffffff;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.05);
  text-align: center;
  /* Kart içindeki elemanları ortalamak için: */
  display: flex;
  flex-direction: column;
  align-items: center;

  /* Kartların genişliği */
  flex: 1;             /* Kartların eşit genişlikte olması için */
  min-width: 250px;    /* Kartların çok küçülmemesi için */
  max-width: 350px;    /* Kartların çok devleşmemesi için */
}
  
  .status {
    color: #666;
    font-size: 0.9rem;
    background: #eee;
    padding: 2px 6px;
    border-radius: 4px;
  }
  
  .custom-button {
    /*margin-bottom: 50px;*/
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background-color: #42b883; /* Vue Yeşili */
    color: white;
    padding: 12px 24px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: bold;
    transition: all 0.3s ease;
    margin-top: 20px;
    border: none;
    cursor: pointer;
  }
  
  .custom-button:hover {
    background-color: #35495e;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(66, 184, 131, 0.4);
  }
  
  .icon {
    font-size: 1.2rem;
  }

  .board {
  display: flex;
  gap: 30px;
  padding: 20px;
  background-color: #f0f2f5;
  border-radius: 12px;
}

.panel {
  flex: 1;
  background-color: #ebedf0;
  padding: 15px;
  border-radius: 10px;
  min-height: 400px;
}

.drag-area {
  min-height: 350px; /* Boş olsa bile içine bırakılabilsin */
}

.drag-card {
  background: white;
  padding: 15px;
  margin-bottom: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  cursor: grab;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
}

.drag-card:active {
  cursor: grabbing;
}

/* Sürükleme sırasındaki gölge efekti */
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
  border: 2px dashed #42b883;
}

.secondary {
  border-left: 5px solid #0678be;
}
  </style>